import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { ShieldCheck } from "@phosphor-icons/react";

export function ForcePasswordChange() {
  const { refresh } = useAuth();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (pw.length < 8) { toast.error("Password must be at least 8 characters"); return; }
    if (pw !== confirm) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { new_password: pw });
      toast.success("Password updated");
      await refresh();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4" data-testid="force-password-change">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-6 shadow-xl">
        <div className="mb-4 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/15 text-primary"><ShieldCheck size={20} weight="fill" /></div>
          <div>
            <h1 className="font-display text-lg font-semibold">Set your new password</h1>
            <p className="text-xs text-muted-foreground">For your security, choose a new password before continuing.</p>
          </div>
        </div>
        <div className="space-y-3">
          <div>
            <label className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">New password</label>
            <input data-testid="force-new-password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="min 8 characters"
              className="mt-1 w-full rounded-xl border border-input bg-background px-3 py-2 text-sm outline-none focus:border-primary" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Confirm password</label>
            <input data-testid="force-confirm-password" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
              className="mt-1 w-full rounded-xl border border-input bg-background px-3 py-2 text-sm outline-none focus:border-primary" />
          </div>
          <button data-testid="force-password-submit" onClick={submit} disabled={busy}
            className="mt-2 w-full rounded-full bg-primary py-2.5 text-sm font-semibold text-primary-foreground disabled:opacity-60">{busy ? "Saving…" : "Update password & continue"}</button>
        </div>
      </div>
    </div>
  );
}
